<template>
    <div class="slideBox" ref="slideBox" :style="{ display: 'flex' }">
        <el-tooltip v-if="slide" popper-class="timeTooltip" effect="dark"
            :content="(Leftyears + $t('common.year') + Leftmonths + $t('common.month') + LeftDay + $t('common.day')).toString()" placement="top">
            <div :style="{
                transform: `translateX(${moveDistanceOne}px)`,
            }" class="point1" :class="{
                'point-box': true,
                zhua: isMove,
            }" @mousedown.stop.prevent="handleMousedownOne" ref="slide1"></div>
        </el-tooltip>

        <el-tooltip v-if="slide" popper-class="timeTooltip" effect="dark"
            :content="(Rightyears + $t('common.year') + Rightmonths + $t('common.month') + RightDay + $t('common.day')).toString()" placement="top">
            <div :style="{
                transform: `translateX(${+moveDistanceTwo + 5}px)`,
            }" class="point2" :class="{
                'point-box': true,
                zhua: isMove,
            }" ref="slide2" @mousedown.stop.prevent="handleMousedownTwo"></div>
        </el-tooltip>
    </div>
</template>
<script>
export default {
    inject: ['selectTime'],
    props: {
        slide: {
            type: Boolean,
            default: true,
        },
        selectWidth: {
            type: Number,
            default: 66,
        },
        scrollX: [Number, String],
        reset: Boolean,
        oneYearDistance: Number,
        setSelectTime: Function,
        getMoveFn: Function,
        openScroll: {
            default: false,
            type: Boolean,
        },
    },
    data () {
        // 计算当前日期的前一个月
        const getPrevMonth = () => {
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth() + 1; // 当前月份（1-12）

            // 计算前一个月的年和月
            let prevYear; let
                prevMonth;
            if (currentMonth === 1) {
                // 若当前是1月，前一个月是去年12月
                prevYear = currentYear - 1;
                prevMonth = 12;
            } else {
                prevYear = currentYear;
                prevMonth = currentMonth - 1;
            }

            // 转换为selectLeftActiveMonth格式：(年份-2021)*12 + 月份
            return (prevYear - 2021) * 12 + prevMonth;
        };
        return {
            isClick: false, // 是否直接点击
            isMove: false, // 是否处于滑动状态
            initRightTime: true,
            moveDistanceOne: 0, // 滑块一的位置
            moveDistanceTwo: 0, // 滑块二的位置
            isInitCompleted: false, // 新增：标记是否已完成初始化联动

            selectLeftDay: 1,
            selectLeftYear: 2021,
            selectLeftActiveMonth: 1,
            selectLeftActiveYear: 2021,
            // -------------------------------
            selectRightPoint: '',
            selectRightMonth: 1,
            selectRightDay: 1,
            selectRightYear: 2021,
            selectRightactiveYear: 2021,
            selectRightActiveMonth: 1,
        };
    },
    watch: {
        selectTime: {
            handler (newVal) {
                this.timeSplit(newVal);
                // 仅在初始化时执行一次联动（避免重复执行）
                if (!this.isInitCompleted) {
                    this.checkRightMonthAndSyncLeft();
                    this.isInitCompleted = true; // 标记初始化完成
                }
                this.updatedSlideFn(); // 额外触发一次，确保位置同步
            },
            immediate: true,
            deep: true,
        },

        selectWidth: {
            handler (val) {
                this.setSelectTime(
                    this.Leftyears,
                    this.Rightyears,
                    this.Leftmonths,
                    this.Rightmonths,
                    this.LeftDay,
                    this.RightDay,
                );
                this.updatedSlideFn();
                let Lefttimes = {
                    yearLeft: this.Leftyears,
                    monthLeft: this.Leftmonths,
                    dayLeft: this.LeftDay,
                };
                let Righttimes = {
                    yearRight: this.Rightyears,
                    monthRight: this.Rightmonths,
                    dayRight: this.RightDay,
                };
                this.$emit('changeSelectTime', 'times', { Lefttimes, Righttimes });
            },
            immediate: true,
        },
        reset: {
            handler (val) {
                this.updatedSlideFn();
            },
            immediate: true,
        },
        isMove: {
            handler (newVal) {
                if (!newVal) {
                    let Lefttimes = {
                        yearLeft: this.Leftyears,
                        monthLeft: this.Leftmonths,
                        dayLeft: this.LeftDay,
                    };
                    let Righttimes = {
                        yearRight: this.Rightyears,
                        monthRight: this.Rightmonths,
                        dayRight: this.RightDay,
                    };
                    this.$emit('changeSelectTime', 'times', { Lefttimes, Righttimes });
                }
            },
        },
        // 移除：实时监听Rightmonths的逻辑，恢复拖动灵活性
    },
    computed: {
        Rightmonths () {
            let month = this.selectRightActiveMonth - this.selectRightactiveYear * 12;
            if (month >= 13) month = 1;
            if (month < 10) month = `0${month}`;
            return month;
        },
        Rightyears () {
            return 2021 + this.selectRightactiveYear;
        },
        RightDay () {
            let day = Math.floor(this.selectRightDay);
            if (day < 10) day = `0${day}`;
            if (day === '00' || !day) day = '01';
            return day;
        },
        Leftmonths () {
            let month = this.selectLeftActiveMonth - this.selectLeftActiveYear * 12;
            if (month >= 13) month = 1;
            if (month < 10) month = `0${month}`;
            if (month === '00') month = new Date().getMonth() + 1;

            return month;
        },
        Leftyears () {
            return 2021 + this.selectLeftActiveYear;
        },
        LeftDay () {
            let day = Math.floor(this.selectLeftDay);
            if (day < 10) day = `0${day}`;
            if (day === '00' || !day) day = '01';
            return day;
        },
    },
    mounted () {
        if (this.openScroll) {
            this.moveDistanceTwo = this.$refs.slideBox && +this.$refs.slideBox.clientWidth;
            this.moveDistanceOne = this.$refs.slideBox
                && +this.$refs.slideBox.clientWidth / 2
                + (this.$refs.slideBox.clientWidth / 24 / 31) * new Date().getDay()
                + 1;
        }
    },

    methods: {
        // 核心方法：仅初始化时校验右侧月份并同步左侧日期
        checkRightMonthAndSyncLeft () {
            // 解析右侧月份为数字（去除前置0）
            const rightMonthNum = parseInt(this.Rightmonths, 10);
            // 只有右侧是1月时才触发联动
            if (rightMonthNum === 1) {
                // 右侧年份减1作为左侧年份
                const targetLeftYear = this.Rightyears - 1;
                // 左侧月份固定为12月
                const targetLeftMonth = 12;
                // 左侧日期和右侧保持一致
                const targetLeftDay = this.RightDay;

                // 更新左侧日期相关变量
                this.selectLeftYear = targetLeftYear;
                this.selectLeftDay = parseInt(targetLeftDay, 10);
                this.selectLeftActiveMonth = (targetLeftYear - 2021) * 12 + targetLeftMonth;
                this.selectLeftActiveYear = targetLeftYear - 2021;

                // 同步更新滑块位置
                this.updatedSlideFn();
                // 同步更新父组件时间
                this.setSelectTime(
                    this.Leftyears,
                    this.Rightyears,
                    this.Leftmonths,
                    this.Rightmonths,
                    this.LeftDay,
                    this.RightDay,
                );
            }
        },

        // 解析时间列表中的两个时间点并更新变量值
        timeSplit (time) {
            // 左边界变量：使用time中的左边界数据覆盖默认值
            this.selectLeftDay = Number(time.dayLeft); // 对应time.dayLeft（7）
            this.selectLeftYear = Number(time.yearLeft); // 对应time.yearLeft（2025）
            // 公式：月份 + (年份-2021)*12 - 1（基于time的年月计算）
            this.selectLeftActiveMonth = (Number(time.yearLeft) - 2021) * 12 + Number(time.monthLeft);

            // 公式：年份 - 2021（基于time.yearLeft计算）
            this.selectLeftActiveYear = Number(time.yearLeft) - 2021;

            // 右边界变量：使用time中的右边界数据覆盖默认值
            this.selectRightMonth = Number(time.monthRight); // 对应time.monthRight（8）
            this.selectRightDay = Number(time.dayRight); // 对应time.dayRight（7）
            this.selectRightYear = Number(time.yearRight); // 对应time.yearRight（2025）
            // 公式：年份 - 2020 - 1（基于time.yearRight计算）
            this.selectRightactiveYear = Number(time.yearRight) - 2020 - 1;

            // 公式：月份 + (年份-2021)*12（基于time的年月计算）
            this.selectRightActiveMonth = Number(time.monthRight) + (Number(time.yearRight) - 2021) * 12;
        },

        // 更新滑块距离
        updatedSlideFn () {
            // 左侧滑块距离计算： 月份 * 每个格子宽度 + 天数 * 格子宽度的1/31
            this.moveDistanceOne = this.selectWidth * (this.selectLeftActiveMonth);

            this.moveDistanceTwo = -7 + this.selectWidth * (this.selectRightActiveMonth) + this.selectWidth / 31;

            this.getMoveFn(
                this.moveDistanceOne,
                this.moveDistanceTwo,
                -7 + this.selectWidth * (new Date().getFullYear() - 2020) * 12,
            );
            if (this.openScroll) {
                // 获取左滑块实时更新距离
                let monthDistanceLeft;
                if (this.Leftyears < 2023 || this.Leftyears - this.Rightyears < 0) {
                    monthDistanceLeft = (this.oneYearDistance / 12) * (this.selectLeftActiveMonth - 1);
                }
                if (this.Leftyears >= 2023) {
                    monthDistanceLeft = (this.oneYearDistance / 12)
                        * (this.selectLeftActiveMonth - 1 - (this.Leftyears - 2022) * 12);
                }
                // 不正常时候;
                if (this.Leftyears - this.Rightyears < 0) {
                    monthDistanceLeft = (this.oneYearDistance / 12)
                        * (this.selectLeftActiveMonth - 1 - 12 - (this.Leftyears - 2022) * 12);
                }
                let dayDistanceLeft = (this.oneYearDistance / 12 / 31) * this.LeftDay;
                this.moveDistanceOne = monthDistanceLeft + dayDistanceLeft;
                // 获取右滑块实时更新距离
                let monthDistanceRight;
                if (this.Rightyears < 2023) {
                    monthDistanceRight = (this.oneYearDistance / 12) * (this.selectRightActiveMonth - 1);
                } else {
                    monthDistanceRight = (this.oneYearDistance / 12)
                        * (this.selectRightActiveMonth - 1 - (this.Rightyears - 2022) * 12);
                }
                let dayDistanceRight = (this.oneYearDistance / 12 / 31) * this.RightDay;
                // 5是微调，我也懵了
                this.moveDistanceTwo = monthDistanceRight + dayDistanceRight - 5;
            }
        },
        // 滑动滑块1（恢复原有逻辑，无修改）
        handleMousedownOne (ev) {
            this.isMove = true;
            let currentDistance = ev.clientX;
            document.onmousemove = (e) => {
                if (this.isMove) {
                    const moveX = e.clientX - currentDistance;
                    currentDistance = e.clientX;

                    this.moveDistanceOne += moveX;
                    // 0是微调
                    this.selectLeftMonth = (
                        (this.moveDistanceOne + 0 + this.scrollX)
                        / this.selectWidth
                    ).toString();
                    this.selectLeftPoint = +`0.${this.selectLeftMonth.split('.')[1]}`;
                    this.selectLeftDay = this.selectLeftPoint * 32;
                    this.selectLeftActiveMonth = Math.floor(+this.selectLeftMonth.split('.')[0] + 1);
                    this.selectLeftActiveYear = Math.floor(this.selectLeftMonth / 12);
                    if (this.selectLeftActiveYear < 0) this.selectLeftActiveYear = 0;
                    if (this.moveDistanceOne > this.moveDistanceTwo) {
                        this.moveDistanceOne = this.moveDistanceTwo;
                    }
                    if (this.moveDistanceOne < 0) this.moveDistanceOne = 0;
                }
                this.setSelectTime(
                    this.Leftyears,
                    this.Rightyears,
                    this.Leftmonths,
                    this.Rightmonths,
                    this.LeftDay,
                    this.RightDay,
                );
                this.getMoveFn(this.moveDistanceOne, this.moveDistanceTwo);
            };
            document.onmouseup = (e) => {
                this.isMove = false;
                document.onmousemove = null;
            };
        },
        // 滑动滑块2（恢复原有逻辑，无修改）
        handleMousedownTwo (ev) {
            this.initRightTime = false;
            this.isMove = true;
            let currentDistance = ev.clientX;
            document.onmousemove = (e) => {
                if (this.isMove) {
                    const moveX = e.clientX - currentDistance;
                    currentDistance = e.clientX;
                    this.moveDistanceTwo += moveX;
                    // 5是微调
                    this.selectRightMonth = (
                        (this.moveDistanceTwo + 5 + this.scrollX)
                        / this.selectWidth
                    ).toString();

                    this.selectRightPoint = +`0.${this.selectRightMonth.split('.')[1]}`;
                    this.selectRightDay = this.selectRightPoint * 32;
                    // this.selectRightDay = this.selectRightPoint / (this.selectWidth / 33);
                    this.selectRightActiveMonth = Math.floor(+this.selectRightMonth.split('.')[0] + 1);
                    this.selectRightactiveYear = Math.floor(this.selectRightMonth / 12);
                    if (this.moveDistanceOne > this.moveDistanceTwo) {
                        this.moveDistanceTwo = this.moveDistanceOne;
                    }
                    // if (this.moveDistanceTwo > +this.$refs.slideBox.clientWidth) {
                    //     this.moveDistanceTwo = +this.$refs.slideBox.clientWidth;
                    // }
                    if (
                        this.moveDistanceTwo
                        >= -6 + (new Date().getFullYear() - 2020) * (this.selectWidth * 12)
                    ) {
                        this.moveDistanceTwo = -6 + (new Date().getFullYear() - 2020) * (this.selectWidth * 12);
                    }
                    // console.log(this.moveDistanceTwo);
                    // console.log(-6 + this.selectRightactiveYear * (this.selectWidth * 12));
                }
                this.setSelectTime(
                    this.Leftyears,
                    this.Rightyears,
                    this.Leftmonths,
                    this.Rightmonths,
                    this.LeftDay,
                    this.RightDay,
                );
                this.getMoveFn(this.moveDistanceOne, this.moveDistanceTwo);
            };
            document.onmouseup = () => {
                this.isMove = false;
                document.onmousemove = null;
            };
        },
    },
};
</script>
<style lang="scss">
.el-tooltip__popper.timeTooltip {
    // padding-left: 12px;
    // padding-top: 1px !important;
    color: white;
    background: rgba(7, 17, 80, 0.75);
    background-clip: padding-box;
    border: 5px solid;
    border-color: transparent;
    border-image: url('./imgs/mark-bg.png') 10 stretch;
    // padding-top: 8px;
    // padding-bottom: 10px;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    font-size: 16px;
}

.el-tooltip__popper.topTooltip {
    padding-left: 12px;
    padding-top: 1px !important;
    color: white;
    background: rgba(7, 17, 80, 0.75);
    background-clip: padding-box;
    border: 12px solid;
    border-color: transparent;
    border-image: url('./imgs/icon-mask.png') 13 stretch;
    // border-image: url('./imgs/mark-bg.png') 15 stretch;
    padding-top: 8px;
    padding-bottom: 10px;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    font-size: 16px;
}
</style>
<style lang="scss" scoped>
.slideBox {
    // position: relative;
    position: absolute;
    // left: 50%;
    top: 0;
    // transform: translateX(-50%);
    height: 20px;
    width: 94.7%;
    // background: rgba(7, 17, 80, 0.6);
}

.slider-box {
    height: 10px;
    border-radius: 20px;
    position: relative;
}

.slider-nei {
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 10px;
    border-radius: 20px;
}

.point1,
.point2 {
    width: 10px;
    height: 14px;
    left: -6px;
    // ../../imgs/middleImgs/select.png
    background: url('./imgs/select.png');

    background-size: 100% 100%;
}

.point-box {
    // width: 43px;
    // height: 20px;
    // border-radius: 20px;
    position: absolute;
    top: 0;
    color: #fff;
    font-size: 12px;
    line-height: 20px;

}

.point-box:hover {
    cursor: grab;
    background: url('./imgs/select_active.png');
    background-size: 100% 100%;
}

.zhua:active {
    cursor: grabbing;
    background: url('./imgs/select_active.png');
    background-size: 100% 100%;
}

.transtion {
    transition: all 0.3s;
}
</style>
